import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from 'app/footer/footer.component';
import { AboutComponent } from './components/about/about.component';
import { DataCardComponent } from './components/data-card/data-card.component';
import { DiscordComponent } from './components/discord/discord.component';
import { ChipComponent } from 'app/common/components/chip/chip.component';
import { ContentCardComponent } from 'app/common/components/content-card/content-card.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { LinksComponent } from 'app/common/components/links/links.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less'],
  imports: [
    FooterComponent,
    AboutComponent,
    DataCardComponent,
    DiscordComponent,
    ChipComponent,
    ContentCardComponent,
    PortfolioComponent,
    LinksComponent,
  ],
})
export class HomeComponent implements OnInit {
  Instagram = 'https://www.instagram.com/verborgia/';
  LinkedIn = 'https://www.linkedin.com/in/l%C3%A9on-zimmermann-62b245135/';
  GitHub = 'https://github.com/ZimmermannLeon';
  Stackoverflow =
    'https://stackoverflow.com/users/8613242/l%c3%a9on-zimmermann';
  Mail = 'mail@zimmermannleon.de';

  chips = [
    'Microsoft Dynamics CRM',
    'Power Platform',
    'Power Pages',
    'Power Automate',
    'Angular',
    'HTML',
    'CSS',
    'LESS/SASS',
    'TypeScript',
    'JavaScript',
    'C#',
    '.NET',
    'Azure Functions',
    'Entity Framework',
    'SQL',
    'Azure AD B2C',
    'Custom Policies',
    'Wordpress',
    'Jira',
    'Fukano',
    'Confluence',
    'GitHub/Git',
    'Azure Pipelines',
    'Netlify',
    'Nginx',
    'Firebase',
    'SAP MM/WM',
    'ABAP',
    'SAP Fiori',
    'Neptun',
  ];

  hobbies = ['Homelab', 'Coding','Botanik', 'Mittelalter', 'Gaming'];

  constructor(private router: Router) {}

  ngOnInit(): void {}
}
